import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { BasicDialog, PrimaryButton, Colors, Text, LoadingIndicator, SecondaryButton } from 'library';
import { styled } from '@mui/material';

export default function DeletePhotoDialog({
    onDelete,
    isOpen,
    onClose,
}: {
    onDelete: () => Promise<void>;
    isOpen: boolean;
    onClose: () => void;
}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const close = () => {
        setLoading(false);
        setError(false);
        onClose();
    };

    const deletePhoto = () => {
        setLoading(true);
        onDelete()
            .then(close)
            .catch((e) => setError(e))
            .finally(() => setLoading(false));
    };

    return (
        <BasicDialog isOpen={isOpen} onClose={close} dialogTitle="Delete Photo?" closeButton>
            <Grid>
                {loading && <LoadingIndicator />}
                {error && (
                    <Text color={Colors.error}>Oops! Something went wrong deleting your photo. Please try again.</Text>
                )}
                <ButtonSection direction="row" container>
                    <CancelButton disabled={loading} onClick={close}>
                        Cancel
                    </CancelButton>
                    <DeleteButton loading={loading} disabled={loading} onClick={deletePhoto}>
                        Delete
                    </DeleteButton>
                </ButtonSection>
            </Grid>
        </BasicDialog>
    );
}

const ButtonSection = styled(Grid)({
    justifyContent: 'space-between',
});

const DeleteButton = styled(PrimaryButton)({
    maxWidth: '30%',
});

const CancelButton = styled(SecondaryButton)({
    maxWidth: '30%',
});
